import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { addFavOrder } from '@kfc-global/react-shared/redux/Actions/OrderHistoryAction';
import parse from 'html-react-parser';
import { InputBox } from 'atoms/InputBox';
import { ButtonComp } from 'atoms/Buttons';
import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import ModalComponent from 'molecules/Modal';
import AddressModalContainer from 'organisms/AddressModel/Container/AddressModalContainer';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import AddEditModalComponent from 'molecules/AddToFavourite/Container/AddEditModalComponent';
import { OPEN, ROUTE_URL } from 'common/constants/SharedConstants';
import {
  getPickupCancelOrderModalJSX,
  getPickupStoreClosedInfoModalJSX,
  getPickupStoreClosingSoonInfoModalJSX,
  getPickupGeoLocationVerifyModalJSX,
  getCurbsidePlateNumberInputModalJSX,
} from '../presentation/sharedTemplates/orderSummaryPickupViewTemplates';
import { checkTimeDuration } from 'common/utilities/utils';
import { STORE_CLOSING_SOON_MODAL_TIMING } from '@kfc-global/react-shared/config/config.constants';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { isCheckedInOrder } from 'common/utilities/orderStatusUtils';
import NeedHelp from 'organisms/NeedHelp/Container/NeedHelp';
/*********************************************************************
 *
 *
 *********************************************************************/
export const getOrderSummaryDirectionMapModal = params => {
  const { orderDetails, updateSetOrderDetails } = params;
  const { deliveryAddress = {}, store, isOpenOrderSummaryDirectionMap = true, isMobileView = false } = orderDetails;

  const closeModalHandler = () => {
    updateSetOrderDetails({ isOpenOrderSummaryDirectionMap: false });
  };

  const googleMapModalProps = {
    role: 'dialog',
    modalTitleId: 'direction-map-modal',
    show: true,
    classNames: 'map-modal',
    showCloseBtn: isOpenOrderSummaryDirectionMap,
    closeButtonHandler: closeModalHandler,
    modalTitle: '',
    showBackBtn: isMobileView,
    closeDataTestId: 'close-direction-map-modal',
    id: 'directionMapModal',
    autoFocus: true,
  };

  const storeLatLng = [store?.location?.latitude, store?.location?.longitude];
  const customerLatLng = [deliveryAddress?.location?.latitude, deliveryAddress?.location?.longitude];

  const getGoogleMap = props => {
    return (
      <LazyLoaderWrapper
        {...props}
        testId='appGoogleMap'
        importPath='APP_GOOGLE_MAP'
        orderTracking={true}
      ></LazyLoaderWrapper>
    );
  };
  return (
    isOpenOrderSummaryDirectionMap && (
      <ModalComponent {...googleMapModalProps}>{getGoogleMap({ storeLatLng, customerLatLng })}</ModalComponent>
    )
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
export const validateOrderNameField = ({ event, params }) => {
  const { orderDetails, updateSetOrderDetails } = params;
  const { orderSummarySaveOrderDetails } = orderDetails;
  const { SPECIAL_CHAR_ERROR, EMPTY_NAME_ERROR } = TRANSLATE_MAPPING_KEY;
  const saveNameObj = { ...orderSummarySaveOrderDetails };
  const inputValue = event?.target?.value;
  saveNameObj.value = inputValue;

  const valid = orderDetails?.favouriteOrderRegex?.test(inputValue);
  if (!inputValue) {
    saveNameObj.error = true;
    saveNameObj.errorMessage = translateWithI18Next(EMPTY_NAME_ERROR);
  } else if (!valid) {
    saveNameObj.error = true;
    saveNameObj.errorMessage = translateWithI18Next(SPECIAL_CHAR_ERROR);
  } else {
    saveNameObj.error = false;
    saveNameObj.errorMessage = '';
  }

  updateSetOrderDetails({ orderSummarySaveOrderDetails: saveNameObj });
  return saveNameObj;
};

/*********************************************************************
 *
 *
 *********************************************************************/
const saveAsAddFavOrder = params => {
  const { orderDetails, closeModalHandler, updateSetOrderDetails } = params;
  const { dispatch, customerId, tenantId, phoneNumber, orderId, orderSummarySaveOrderDetails } = orderDetails;

  if (validateOrderNameField({ params })?.error === false) {
    dispatch(
      addFavOrder({ customerId, tenantId, phoneNumber }, { orderId, name: orderSummarySaveOrderDetails?.value }),
    );
    updateSetOrderDetails({ orderSummarySaveYourOrderCompleted: true });
    closeModalHandler();
  }
};

/*********************************************************************
 *
 *
 *********************************************************************/
export const getSaveYourOrdersModalJSX = params => {
  const { orderDetails, closeModalHandler } = params;
  const { isMobileView, orderSummarySaveOrderDetails } = orderDetails;

  return (
    <div className='modalContants'>
      <div className='fontstyle'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.SAVE_ORDER_THANKYOU)}</div>
      <div className='fontstyle'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.WE_SAVED)}</div>
      <div className='fontstyle'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.GIVE_A_NAME)}</div>

      <div className={`inputbox ${isMobileView ? '' : 'trackOrderScreen'}`}>
        <InputBox
          value={orderSummarySaveOrderDetails?.value}
          className='inputfield'
          placeholder='Name This Order'
          data-testid='modal-coupon-input-field'
          onChange={event => validateOrderNameField({ event, params })}
        />
        {orderSummarySaveOrderDetails?.error && (
          <div id='saveTrackOrderScreen' className='error-text'>
            <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
            <span className='error-msg' role='alert'>
              {orderSummarySaveOrderDetails?.errorMessage}
            </span>
          </div>
        )}
      </div>

      <div className='buttonItems'>
        <ButtonComp
          data-testid='coupon-button-one'
          className='button whiteButton blackBorder closebtn-cls'
          onClick={closeModalHandler}
        >
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CANCEL)}
        </ButtonComp>
        <ButtonComp
          data-testid='coupon-button-two'
          className='button blackButton blackBorder save-button'
          onClick={() => saveAsAddFavOrder(params)}
          disabled={orderSummarySaveOrderDetails?.error}
        >
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.SAVE)}
        </ButtonComp>
      </div>
    </div>
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
export const returnToastJsx = favoritesText => {
  const { FAVORITE_ORDERS } = TRANSLATE_MAPPING_KEY;
  return `<a href='${ROUTE_URL.ACCOUNT}#${FAVORITE_ORDERS}' className='favorites-hyperlink-style'><u>${favoritesText}</u></a>`;
};

export const modifytoastmessage = (ORDER_ADDED_TO_FAVOURITE, FAVOURITES) => {
  const message = translateWithI18Next(ORDER_ADDED_TO_FAVOURITE);
  const favoritesText = translateWithI18Next(FAVOURITES);
  const favoritesTextLine = returnToastJsx(favoritesText);
  const replacedMsg = message?.replace('Favourites', favoritesTextLine);
  return parse(String(replacedMsg));
};

/*********************************************************************
 *
 *
 *********************************************************************/
export const getAddEditFavouriteModal = params => {
  const { orderDetails, updateSetOrderDetails } = params;
  const { orderId, isOpenOrderSummarySaveYourOrderCheckoutFaster } = orderDetails;
  const { ORDER_ADDED_TO_FAVOURITE, FAVOURITES } = TRANSLATE_MAPPING_KEY;
  const toastmessage = modifytoastmessage(ORDER_ADDED_TO_FAVOURITE, FAVOURITES);
  const closeModalHandler = () => {
    updateSetOrderDetails({ isOpenOrderSummarySaveYourOrderCheckoutFaster: false });
  };

  return (
    isOpenOrderSummarySaveYourOrderCheckoutFaster && (
      <AddEditModalComponent
        showOccassionModal={isOpenOrderSummarySaveYourOrderCheckoutFaster}
        updateSetOrderDetails={updateSetOrderDetails}
        setOccassionModalOpen={closeModalHandler}
        occasionName={''}
        setOccasionName={name => console.log(name)}
        cardInfo={{ id: orderId }}
        toastmessage={toastmessage}
        isAddFavOrderBox={true}
      />
    )
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
export const getSaveYourOrdersModal = params => {
  const { orderDetails, updateSetOrderDetails } = params;
  const { isMobileView, isOpenOrderSummarySaveYourOrderCheckoutFaster } = orderDetails;

  const closeModalHandler = () => {
    updateSetOrderDetails({ isOpenOrderSummarySaveYourOrderCheckoutFaster: false });
  };

  const saveYourOrdersModalProps = {
    id: 'orderSaveModal',
    role: 'dialog',
    modalTitleId: 'order-save-modal',
    show: isOpenOrderSummarySaveYourOrderCheckoutFaster,
    classNames: 'save-order-modal',
    showCloseBtn: true,
    closeButtonHandler: closeModalHandler,
    modalTitle: '',
    showBackBtn: isMobileView,
    closeDataTestId: 'close-order-save-modal',
    autoFocus: true,
  };

  return (
    isOpenOrderSummarySaveYourOrderCheckoutFaster && (
      <ModalComponent {...saveYourOrdersModalProps}>
        {getSaveYourOrdersModalJSX({ ...params, closeModalHandler })}
      </ModalComponent>
    )
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
const getDeliveryAddressFormattedData = addresses => {
  let data = {};
  let addressLines = ['', ''];
  addressLines[1] = addresses?.addressLines[1];
  addressLines[0] = addresses?.addressLines[0];
  data = {
    id: addresses?.id || '',
    addressName: addresses?.name || '',
    city: addresses?.city,
    pinCode: addresses?.pinCode,
    state: addresses?.state,
    country: addresses?.country || '',
    location: {
      latitude: addresses?.location?.latitude,
      longitude: addresses?.location?.longitude,
    },
    addressLines: addressLines,
    deliveryInstruction: addresses?.deliveryInstructions || '',
    deliveryOptions: addresses?.deliveryOptions || '',
  };
  return data;
};

/*********************************************************************
 *
 *
 *********************************************************************/
export const getSaveYourDeliveryAddressModal = params => {
  const { orderDetails, updateSetOrderDetails } = params;
  const { isOpenSaveDeliveryAddressModal, deliveryAddress } = orderDetails;
  const updatedDeliveryAddressObj = getDeliveryAddressFormattedData(deliveryAddress);
  const isAddressFromOrderProcessing = true;

  const closeModal = () => {
    updateSetOrderDetails({ isOpenSaveDeliveryAddressModal: false });
  };

  return (
    isOpenSaveDeliveryAddressModal && (
      <div className='addresses-and-stores-container'>
        <AddressModalContainer
          data-testid='address-modal'
          address={updatedDeliveryAddressObj}
          isOpen={isOpenSaveDeliveryAddressModal}
          updateSetOrderDetails={updateSetOrderDetails}
          toggleModal={closeModal}
          isAddressFromOrderProcessing={isAddressFromOrderProcessing}
        />
      </div>
    )
  );
};

/*********************************************************************
 * getPickupCancelOrderModal
 * params
 *********************************************************************/
export const getPickupCancelOrderModal = params => {
  const { orderDetails, updateSetOrderDetails } = params;
  const { isShowPickupOrderCancelModal } = orderDetails;

  const closeModalHandler = () => {
    updateSetOrderDetails({ isShowPickupOrderCancelModal: false });
  };

  const modalProps = {
    id: 'pickupCancelOrderModal',
    role: 'dialog',
    modalTitleId: 'pickupCancelOrderModal',
    show: true,
    classNames: `Base-modal pickupCancelOrderBaseModal`,
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: closeModalHandler,
    modalTitle: '',
    modalTitleRequired: false,
    // backButtonHandler: handleClose,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };

  return isShowPickupOrderCancelModal ? (
    <ModalComponent {...modalProps}>{getPickupCancelOrderModalJSX({ ...params, closeModalHandler })}</ModalComponent>
  ) : null;
};

/*********************************************************************
 * getPickupGeoLocationVerifyModal
 * params
 *********************************************************************/
export const getPickupGeoLocationVerifyModal = params => {
  const { orderDetails, updateSetOrderDetails } = params;
  const { isShowPickupOrderCheckReadyToPrepareModal } = orderDetails;

  const closeModalHandler = () => {
    updateSetOrderDetails({ isShowPickupOrderCheckReadyToPrepareModal: false });
  };

  const modalProps = {
    id: 'pickupGeoLocationVerifyModal',
    role: 'dialog',
    modalTitleId: 'pickupGeoLocationVerifyModal',
    show: true,
    classNames: `Base-modal pickupCancelOrderBaseModal`,
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: closeModalHandler,
    modalTitle: '',
    modalTitleRequired: false,
    // backButtonHandler: handleClose,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };

  return isShowPickupOrderCheckReadyToPrepareModal ? (
    <ModalComponent {...modalProps}>
      {getPickupGeoLocationVerifyModalJSX({ ...params, closeModalHandler })}
    </ModalComponent>
  ) : null;
};

/*********************************************************************
 * getPickupStoreClosedInfoModal
 * params
 *********************************************************************/
export const getPickupStoreClosedInfoModal = params => {
  const { orderDetails } = params;
  const { pickupClosedInfoModal, buffertimepmpickup = 30 } = orderDetails;

  const modalProps = {
    id: 'pickupClosedInfoModal',
    role: 'dialog',
    modalTitleId: 'pickupClosedInfoModal',
    show: true,
    classNames: `Base-modal pickupClosedInfoModalBaseModal`,
    showCloseBtn: true,
    showBackBtn: false,
    modalTitle: '',
    modalTitleRequired: false,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };
  const storeData = { ...orderDetails?.store, ...{ status: { currentStatus: OPEN, message: OPEN } } };
  const result = checkTimeDuration(storeData, buffertimepmpickup);
  return !isCheckedInOrder(orderDetails) && pickupClosedInfoModal && result?.timingFlag ? (
    <ModalComponent {...modalProps}>{getPickupStoreClosedInfoModalJSX({ ...params })}</ModalComponent>
  ) : null;
};

/*********************************************************************
 * closeCurbsidePlateNumberInputModel - called to close the curbside car number plate modal
 * params
 *********************************************************************/
export const closeCurbsidePlateNumberInputModel = params => {
  const { updateSetOrderDetails } = params;
  updateSetOrderDetails({
    isShowCurbsidePlateNumberInputModal: false,
  });
};

/*********************************************************************
 * getCurbsidePlateNumberInputModal - displays the curbside car number plate modal
 * params
 *********************************************************************/
export const getCurbsidePlateNumberInputModal = params => {
  const { orderDetails } = params;
  const { isShowCurbsidePlateNumberInputModal } = orderDetails;

  const modalProps = {
    id: 'curbsidePlateNumberInputModal',
    role: 'dialog',
    modalTitleId: 'curbsidePlateNumberInputModal',
    show: true,
    classNames: `Base-modal pickupClosedInfoModalBaseModal`,
    showCloseBtn: true,
    closeButtonHandler: () => closeCurbsidePlateNumberInputModel(params),
    showBackBtn: false,
    modalTitle: '',
    modalTitleRequired: false,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };
  return !isCheckedInOrder(orderDetails) && isShowCurbsidePlateNumberInputModal ? (
    <ModalComponent {...modalProps}>{getCurbsidePlateNumberInputModalJSX({ ...params })}</ModalComponent>
  ) : null;
};

/*********************************************************************
 * getPickupStoreClosingSoonInfoModal
 * params
 *********************************************************************/
export const getPickupStoreClosingSoonInfoModal = params => {
  const { orderDetails } = params;
  const { pickupClosingSoonModal } = orderDetails;

  const modalProps = {
    id: 'pickupClosingSoonModal',
    role: 'dialog',
    modalTitleId: 'pickupClosingSoonModal',
    show: true,
    classNames: `Base-modal pickupClosingSoonModalBaseModal`,
    showCloseBtn: true,
    showBackBtn: false,
    modalTitle: '',
    modalTitleRequired: false,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };
  const storeData = { ...orderDetails?.store, ...{ status: { currentStatus: OPEN, message: OPEN } } };
  const result = checkTimeDuration(storeData, config(STORE_CLOSING_SOON_MODAL_TIMING));
  return !isCheckedInOrder(orderDetails) && pickupClosingSoonModal && result?.timingFlag ? (
    <ModalComponent {...modalProps}>
      {getPickupStoreClosingSoonInfoModalJSX({ ...params, lastCheckIn: result?.lastCheckInTime })}
    </ModalComponent>
  ) : null;
};

/*********************************************************************
 * getOrderSummaryModals
 * props
 *********************************************************************/
export const getOrderSummaryModals = props => {
  return (
    <>
      {getOrderSummaryDirectionMapModal(props)}
      {getAddEditFavouriteModal(props)}
      {getSaveYourDeliveryAddressModal(props)}
      {getPickupCancelOrderModal(props)}
      {getPickupGeoLocationVerifyModal(props)}
      {getPickupStoreClosedInfoModal(props)}
      {getPickupStoreClosingSoonInfoModal(props)}
      {getCurbsidePlateNumberInputModal(props)}
    </>
  );
};

export const handleCloseNeedHelp = updateSetOrderDetails => {
  updateSetOrderDetails({
    openCallSupportModal: false,
  });
};

export const getCallSupportModalView = (openCallSupportModal, updateSetOrderDetails) => {
  return (
    <NeedHelp
      isOpen={openCallSupportModal}
      checkoutHeader={false}
      showOrderSummaryHeader={true}
      handleClose={() => handleCloseNeedHelp(updateSetOrderDetails)}
    />
  );
};

export const setEnablePickupCallSupportModal = params => {
  const { updateSetOrderDetails, orderDetails } = params;
  if (orderDetails.enableCancelOrderCallsupportModal) {
    updateSetOrderDetails({
      isShowPickupOrderCancelModal: false,
      openCallSupportModal: true,
      pickupCancelOrder: !orderDetails?.enableCancelOrderCallsupportModal,
    });
  } else {
    updateSetOrderDetails({
      isShowPickupOrderCancelModal: false,
      pickupCancelOrder: true,
    });
  }
};

export const encryptGuestUserData = userData => {
  const unicCodesArray = [];
  for (const char of userData) {
    const uniCode = char.codePointAt(0);
    unicCodesArray.push(uniCode);
  }
  const code = unicCodesArray.join('%');
  return btoa(code);
};
